import {Argument} from '@app/core/model/filtering/argument';
import {FilterPredicate} from '@app/core/model/filtering/filter-predicate';

export class PropertyFilterModel {
    public arguments: Array<Argument> = <Argument[]>[];
    public isSupportMultipleArgument: boolean;
    public isRequireArguments: boolean;

    constructor(
        public propertyName: string = null,
        public predicateName: FilterPredicate = null,
        public args: Array<Argument> = <Argument[]>[],
        public propertyFilterId: string = null
    ) {
        this.arguments = args;
    }

    static toString(propertyFilter: PropertyFilterModel): string {
        const args = (propertyFilter.arguments || propertyFilter.args)
            .map((arg: Argument) => JSON.stringify(arg))
            .sort();
        return JSON.stringify({
            propertyName: propertyFilter.propertyName,
            predicateName: propertyFilter.predicateName,
            args: args
        });
    }
}
